import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getConsent } from '../../sdk/services/contentService';
import amwayLogo from '../../../src/assets/image/Amw_Logo_Black.webp';
import { LoggerService } from '../../ui/utils';
import styles from './Privacy.module.scss';

export const PrivacyMain = () => {
  const { t } = useTranslation();

  const [privacyPolicy, setPrivacyPolicy] = useState('');
  const navigate = useNavigate();
  const [date, setDate] = useState('');
  const cacheKey = 'PrivacyPolicy';

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const data = await getConsent(cacheKey, true);

        if (typeof data === 'object' && data !== null) {
          setPrivacyPolicy(data.privacy_and_policy ?? '');
          let date = moment(data.date).format('MMMM D, YYYY');
          setDate(date ?? '');
        }
      } catch (error) {
        LoggerService.log('fetchPrivacyPolicy: Failed to retrieve content data.');
      }
    };
    fetchPrivacyPolicy();
  }, []);

  return (
    <>
      <div className={styles['term-container']}>
        <div className={styles['image-container']}>
          <img onClick={() => navigate('/')} className={styles['logo']} src={amwayLogo} alt="amway logo" height={30} />
        </div>
        <p className={styles['term-container-header']}>
          <b>{t('dashboard.privacyPolicy.label.header')}</b>
        </p>

        <div className={styles['content-container']}>
          <div className={styles['content']}>
            <article className={styles['security-privacy-box']}>
              <h3 className={styles['security-privacy-box-header']}>
                <strong>{t('dashboard.privacyPolicy.label.termsAndConditions')}</strong>
              </h3>
              <p className={styles['security-privacy-box-date']}>
                <strong>{t('dashboard.privacyPolicy.label.lastRevised').replace('{date}', date)}</strong>
              </p>
              <p dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
            </article>
          </div>
        </div>
      </div>
    </>
  );
};
